import { render } from "./SvgIcon.vue?vue&type=template&id=6dc925df"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=6dc925df&lang=less"
script.render = render

export default script